module.exports = __webpack_public_path__ + "static/media/facebook.649db303.svg";